import { render, staticRenderFns } from "./CowVaccination.vue?vue&type=template&id=adb07b86&scoped=true&"
import script from "./CowVaccination.vue?vue&type=script&lang=js&"
export * from "./CowVaccination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb07b86",
  null
  
)

export default component.exports